import { useCallback } from 'react';
const useFileHandler = (cb: (file: File) => void) => {
  const handler = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const [file] = e.target.files || [];
    if (!file) {
      return;
    }
    cb(file);
    e.target.value = '';
    e.target.files = null;
  }, [cb]);
  return handler;
};
export default useFileHandler;